export const NameCellClass = 'name-cell';
export const GroupCellClass = 'group-cell';
export const SecondaryCellClass = 'secondary-cell';
export const TotalCellClass = 'total-cell';
export const paginationOptions = [100, 250, 500];
